import { BaseService } from '@myhealth-raccoon/services';

import { UserWithSiteModel } from './types';

class UserService extends BaseService {
    constructor() {
        super('v1/user', import.meta.env.VITE_BP_API_URL);
    }

    public async GetSitesByUmbracoUser(umbracoId: string | number) {
        return this.get<UserWithSiteModel[]>(`umbraco/${umbracoId}/sites`);
    }
}

export const userService = new UserService();
export * from './types';
